<template>
  <el-dialog
    width="900px"
    custom-class="import-dialog"
    title="选择商店"
    :visible="visible"
    @close="close"
  >
    <div class="p20">
      <div class="table-panel flex flex-between">
        <div class="flex-1 text-right">
          <el-input
            clearable
            style="width: 200px"
            v-model.trim="searchCondition.queryKey"
            placeholder="请输入关键词/商店名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-cascader
            clearable
            style="margin-right: 10px"
            ref="cascader"
            v-model="searchCondition.departId"
            :props="props"
            :show-all-levels="false"
            size="small"
            placeholder="请选择机构"
          ></el-cascader>

          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <el-table
          stripe
          border
          ref="table"
          :highlight-current-row="radio"
          @current-change="handleCurrentChange"
          @selection-change="handleSelectionChange"
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
          max-height="500"
        >
          <el-table-column
            v-if="!radio"
            type="selection"
            :selectable="selectEnable"
          ></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            prop="shopCode"
            label="商店编号"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="商店名称"
            show-overflow-tooltip
            width="240"
          >
          </el-table-column>
          <el-table-column
            prop="shopAddress"
            label="地址"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.shopAddress }}{{ scope.row.shopDetailAddress }}
            </template>
          </el-table-column>
          <el-table-column
            prop="syncFlag"
            label="是否实体店"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.syncFlag === "hemiao" ? "虚拟店" : "实体店"
              }}</span>
              <span></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="departName"
            label="所属机构"
            header-align="center"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <div class="btn-wrapper mb20 flex flex-center">
        <el-button size="small" type="primary" @click="saveShops"
          >确 定</el-button
        >
        <el-button size="small" @click="close">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    radio: {
      type: Boolean,
      default: false,
    },
    enabelList: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store",
              })
              .then((res) => {
                res.result.records.forEach((v) => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.id;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "store",
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.id;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      checkedRow: [],
      checkedCurrentRow: {},
      searchCondition: {},
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
    };
  },
  computed: mapGetters(["shopList"]),
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    selectEnable(row) {
      if (
        this.enabelList.some((item) => item.wxshopSkuId === row.wxshopSkuId)
      ) {
        return false;
      } else {
        return true; // 不禁用
      }
    },
    saveShops() {
      if (this.radio) {
        this.$emit("setLink", this.checkedCurrentRow);
      } else {
        this.$emit("saveShops", this.checkedRow);
      }
    },
    handleSelectionChange(row) {
      this.checkedRow = row;
    },
    handleCurrentChange(row) {
      this.checkedCurrentRow = row;
    },
    close() {
      this.$emit("close");
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.departId == "object") {
        searchCondition.departId = searchCondition.departId[searchCondition.departId.length - 1];
      }
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("queryShopList", params);
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    getChecked(selection) {
      this.checkedRow = selection.map((v) => v.spuId);
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
